import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Theme } from '@/types';

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggle: () => void;
}

const THEME_STORAGE_KEY = 'sqluz-theme';

/** Temani <html data-theme> ga qo'llaydi. */
function applyTheme(theme: Theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'light', // DEFAULT: yorug'
      setTheme: (theme) => {
        applyTheme(theme);
        set({ theme });
      },
      toggle: () => {
        const next: Theme = get().theme === 'light' ? 'dark' : 'light';
        applyTheme(next);
        set({ theme: next });
      },
    }),
    {
      name: THEME_STORAGE_KEY,
      // Prerender hydration server markup'i ('light') bilan mos bo'lishi uchun
      // saqlangan qiymat App mount bo'lgandan keyin tiklanadi (rehydrate).
      skipHydration: true,
      // Faqat tema qiymati saqlanadi (JSON emas, sof string bilan mos)
      storage: {
        getItem: (name) => {
          const value = localStorage.getItem(name);
          return value ? { state: { theme: value as Theme }, version: 0 } : null;
        },
        setItem: (name, value) => {
          localStorage.setItem(name, value.state.theme);
        },
        removeItem: (name) => localStorage.removeItem(name),
      },
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state.theme);
      },
    },
  ),
);
